import type { PumsemChangeKind } from '../model/pumsem.type';
import { CHANGE_STYLE } from './pumsemStyles';

interface PumsemChangeBadgeProps {
  change: PumsemChangeKind;
  /** 앞에 붙일 판 표기(`'26상`). 상세 표의 행 배지에서 쓴다. */
  editionLabel?: string;
  className?: string;
}

/** 개정 배지. `UNCHANGED` 면 아무것도 그리지 않는다. */
export function PumsemChangeBadge({
  change,
  editionLabel,
  className = '',
}: PumsemChangeBadgeProps) {
  const style = CHANGE_STYLE[change];
  if (!style) return null;

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-[12px] font-bold ${style.chip} ${className}`}
    >
      {editionLabel ? `${editionLabel} ${style.label}` : style.label}
    </span>
  );
}
